<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, value }">
      <v-btn :x-small="$vuetify.breakpoint.smAndDown" text :color="color" v-on="on">
        {{$t($i18n.locale)}}
        <v-icon
          small
          :x-small="$vuetify.breakpoint.smAndDown"
        >{{value?'keyboard_arrow_up':'keyboard_arrow_down'}}</v-icon>
      </v-btn>
    </template>
    <v-list class="py-0">
      <v-list-item
        :class="{'small':$vuetify.breakpoint.smAndDown}"
        v-for="lang in SUPPORTED_LANGUAGES"
        :key="lang"
        @click="handleChangeLocale(lang)"
      >{{$t(lang)}}</v-list-item>
    </v-list>
  </v-menu>
</template>
<script lang="ts">
import Vue from "vue";
import { LocaleService } from "@/services/storage.service";
import { setApiServiceLocale } from "@/services/api.service";
import { SUPPORTED_LANGUAGES } from "@/config/const";

export default Vue.extend({
  props: ["color"],
  computed: {
    SUPPORTED_LANGUAGES() {
      return SUPPORTED_LANGUAGES.filter(i => i !== this.$i18n.locale);
    }
  },
  methods: {
    handleChangeLocale(locale: string) {
      if (locale === this.$i18n.locale) return;
      this.$i18n.locale = locale;
      LocaleService.setLocale(locale);
      setApiServiceLocale();
    }
  }
});
</script>
<style lang="scss" scoped>
.small {
  font-size: 10px;
  line-height: 12px;
  padding: 0 8px;
  min-height: 30px;
  align-items: center;
}
</style>